import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Je Suis Jalous",
  "description": "",
  "published": "2007-05-17T00:00:00.000Z",
  "redirect_from": ["/blog/je-suis-jalous/swizec/208"],
  "categories": "video",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`S pogledom v `}<a parentName="p" {...{
        "href": "http://www.brassgoggles.co.uk/brassgoggles/"
      }}>{`Medeninasta OÄala`}</a>{` sem našel tale lušten filmÄek. Ne vem kaj me na njem privlaÄi bolj, izjemna privlaÄnost nenavadnega stila ali prijetna tekoÄnost same pesmi. Verzijo z angleškimi podnapisi lahko najdete `}<a parentName="p" {...{
        "href": "http://www.youtube.com/watch?v=yXc1mApqusY"
      }}>{`tu`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      